export default __webpack_public_path__ + "static/media/whoosh.6712901c.mp3";